import React from "react";
import style from "./overView.module.css";
import photo from "../../img/PFP.jpg";

export default function OverView() {
  return (
    <div className={style.container} id="home">
      <img className={style.img} src={photo} alt="" />
      <div className={style.infoContainer}>
        <h1>Pedro Muñoz</h1>

        <h3>Full stack Developer</h3>

        <p>
          Hola soy Pedro Muñoz👋, Soy un apacionado de la tecnologia llevo mas
          de un año en el mundo del desarrollo web, he trabajo en multiples
          proyectos a nivel invididual o en grupo, trabaje un año como soporte
          en sistema en el cual tambien desarrolle software con un gran equipo
          de developers, actualmente estoy usando React PostGresSQl y node.js
          como stack pero siempre estoy abierto a aprender muchas mas
          tecnologias 👨‍💻
        </p>
      </div>
    </div>
  );
}
